
module.directive('initiativeWidget', function() {
    return {
        restrict: 'E',
        templateUrl: 'programs/initiatives/initiativeWidget',
        scope: {initiative: '='},
    }
});


module.directive('initiative', function() {
    return {
        restrict: 'E',
        template: [
            '<span class="init-color {{ initiative.color }}"">',
                '<svg>',
                    '<use ng-attr-xlink:href="{{\'#\' + initiative.icon}}" xlink:href="")></use>',
                '</svg>',
                '<span class="code">{{ initiative.code }}</span>',
                '<span class="name">{{ initiative.name }}</span>',
            '</span>' ,
        ].join(''),
        scope: {initiative: '='},
    }
});
